import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import { UserModule } from "@/store/modules/user";
import { uploadAudioCover } from "@/api/material";
import { getImageDetailList, requestImageDelete, requestImageSave } from '@/api/live';
import { Throttle } from '@/decorators';
let ImageBank = class ImageBank extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.images = [];
        this.searcher = {
            title: '',
            _title: '',
        };
        this.paginator = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
        this.imageEditor = {
            visible: false,
            loading: false,
            content: {
                id: '',
                name: '',
                picUrl: '',
                linkUrl: '',
                type: 1,
            }
        };
        this.isCoverUploading = false;
        this.liveModal = {
            visible: false,
            list: [],
            _list: [],
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            }
        };
    }
    created() {
        this.loadImageList();
    }
    async loadImageList() {
        this.loading = true;
        const params = {
            name: this.searcher._title || void 0,
            pageNo: this.paginator.pageNo,
            pageSize: this.paginator.pageSize
        };
        try {
            const res = await getImageDetailList(params);
            const data = res.data.data;
            this.images = data.list || [];
            this.paginator.total = Number(data.total);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.loading = false;
        }
    }
    handleImageSearch() {
        this.searcher._title = this.searcher.title;
        this.paginator.pageNo = 1;
        this.loadImageList();
    }
    handlePageChange(pageNo) {
        this.paginator.pageNo = pageNo;
        this.loadImageList();
    }
    async handleImageDelete(image) {
        if (image.liveNameList.length) {
            return this.$message.error('该视频已关联直播，需到关联直播将该图片移除');
        }
        try {
            await this.$confirm('是否确认删除该图片', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
        }
        catch (error) {
            return;
        }
        try {
            await requestImageDelete(image.id);
            this.$message.success('删除成功');
            this.loadImageList();
        }
        catch (error) {
            console.error(error);
        }
    }
    showImageEditor(image) {
        this.imageEditor = {
            visible: true,
            loading: false,
            content: image ? {
                id: image.id,
                name: image.name,
                picUrl: image.picUrl,
                linkUrl: image.linkUrl,
                type: image.type,
            } : {
                id: '',
                name: '',
                picUrl: '',
                linkUrl: '',
                type: 1,
            }
        };
    }
    closeImageEditor() {
        this.imageEditor.visible = false;
    }
    handleImageAddClick() {
        this.showImageEditor();
    }
    handleImageEditClick(image) {
        if (image.liveNameList.length) {
            return this.$message.error('该视频已关联直播，需到关联直播将该图片移除');
        }
        this.showImageEditor(image);
    }
    handleCoverSelect(file) {
        // const isLt5M: boolean = file.size / 1024 / 1024 < 5;
        // if (!isLt5M) {
        //     this.$message.error("封面图片大小不能超过 5MB!");
        //     return false;
        // }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    async handleCoverUpload(data) {
        this.isCoverUploading = true;
        const file = data.file;
        try {
            const res = await uploadAudioCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverUploading = false;
            });
            if (res.data.status !== 200) {
                this.coverUploaderRef.clearFiles();
            }
            else {
                this.imageEditor.content.picUrl = res.data.data;
                this.imageEditFormRef.validateField('picUrl');
            }
        }
        catch {
            this.isCoverUploading = false;
        }
    }
    resetImageList() {
        this.searcher = {
            title: '',
            _title: '',
        };
        this.loadImageList();
    }
    async handleImageSave() {
        try {
            await this.imageEditFormRef.validate();
        }
        catch (error) {
            return;
        }
        const image = this.imageEditor.content;
        const data = {
            id: image.id ? image.id : void 0,
            name: image.name,
            picUrl: image.picUrl,
            linkUrl: image.linkUrl,
            type: image.type,
        };
        this.imageEditor.loading = true;
        try {
            await requestImageSave(data);
            this.$message.success('保存成功');
            this.resetImageList();
            this.closeImageEditor();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.imageEditor.loading = false;
        }
    }
    showLivesModal(lives) {
        if (!lives.length)
            return;
        this.liveModal = {
            visible: true,
            list: lives.slice(0, 10),
            _list: lives,
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: lives.length,
            }
        };
    }
    closeLiveModal() {
        this.liveModal.visible = false;
    }
    handleLivePageChange(pageNo) {
        this.liveModal.paginator.pageNo = pageNo;
        const pageSize = this.liveModal.paginator.pageSize;
        const start = (pageNo - 1) * pageSize;
        this.liveModal.list = this.liveModal._list.slice(start, start + pageSize);
    }
};
tslib_1.__decorate([
    Ref()
], ImageBank.prototype, "coverUploaderRef", void 0);
tslib_1.__decorate([
    Ref()
], ImageBank.prototype, "imageEditFormRef", void 0);
tslib_1.__decorate([
    Ref()
], ImageBank.prototype, "commentEditorRef", void 0);
tslib_1.__decorate([
    Throttle(500)
], ImageBank.prototype, "handleImageSave", null);
ImageBank = tslib_1.__decorate([
    Component({
        name: 'ImageBank',
        filters: {
            formatImageType(type) {
                return [, '讲解图片', '商品图片'][type] || '';
            }
        }
    })
], ImageBank);
export default ImageBank;
